const updates = [
  {
    date: '07.31',
    tag: '新剧上线',
    title: '古装大剧《长安幻夜》今日开播',
    desc: '由顶流演员阵容打造的古装权谋大剧正式上线，首播6集一次性放出，最新电视剧更新速度拉满。',
  },
  {
    date: '07.30',
    tag: '电影定档',
    title: '科幻巨制《星际远征》确定8月15日上映',
    desc: '最新电影上映消息：年度最受期待的科幻大片定档暑期，预售已开启，特效拉满值得期待。',
  },
  {
    date: '07.29',
    tag: '综艺更新',
    title: '《声入人心》第三期收视再创新高',
    desc: '最新综艺在线数据显示本期收视率突破3%，六强选手神仙打架名场面不断。',
  },
  {
    date: '07.28',
    tag: '口碑推荐',
    title: '冷门佳作《山海之间》豆瓣升至9.2分',
    desc: '这部低调的纪录片凭借口碑持续发酵，成为今年最高分的国产纪录电影之一，影视动态持续关注。',
  },
  {
    date: '07.27',
    tag: '剧集动态',
    title: '《都市边缘》最终季确认共12集',
    desc: '十年陪伴迎来完结篇，官方确认全季12集每周更新一集，全球剧迷翘首以待。',
  },
  {
    date: '07.26',
    tag: '平台公告',
    title: '久久影视全新改版，追剧体验全面升级',
    desc: '新版首页上线，新增专题合集与热度榜单功能，让你第一时间掌握影视更新动态。',
  },
  {
    date: '07.25',
    tag: '海外资讯',
    title: '韩剧《那年冬天》确认引进国内平台',
    desc: '这部在韩国收视口碑双丰收的治愈剧已确认引进，中文字幕版即将上线国内主流平台。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            影视动态实时追踪，不错过每一条重要更新
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className="relative mb-8 last:mb-0"
              >
                <div className="absolute -left-[25px] md:-left-[29px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="flex items-center gap-3 mb-1.5 flex-wrap">
                  <span className="text-xs font-medium text-primary-600 whitespace-nowrap">{item.date}</span>
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}